module.exports = __webpack_public_path__ + "static/media/Sidebar-transfers-icon-active.49339a89.svg";